export default {
  dailyTips: () => "tips",
  createDailyTip: () => "tips",
  editDailyTip: (id) => `tips/${id}`,
  deleteDailyTip: (id) => `tips/${id}`,
  checkLastVisitDate: () => "visits/tip",
}
